module.exports = __webpack_public_path__ + "b53927178a6584a14a233285605751f5.png";